var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-chi",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "chi-default-item",
          "item-group-layout": "title-above",
          "is-title-box-visible": "",
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-chi",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "chi-default-item",
          "item-group-layout": "title-above",
          "is-title-box-visible": "",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }